__turbopack_context__.v({
  "className": "inter_94bba844-module__sVRE-a__className",
  "variable": "inter_94bba844-module__sVRE-a__variable",
});
